var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12"},[(_vm.$route.name === 'projectSettingsQueues')?_c('QueuesTable'):(_vm.$route.name === 'projectSettingsQueuesCreate')?_c('QueuesCreate'):(_vm.$route.name.includes('projectSettingsQueuesEdit'))?_c('QueuesDetails'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }